import {
    ADD_CUSTOMER_ADREESS_REQUEST, ADD_CUSTOMER_ADREESS_SUCCESS, ADD_CUSTOMER_ADREESS_ERROR,
    GET_ONE_CUSTOMER_ADREESS_REQUEST, GET_ONE_CUSTOMER_ADREESS_SUCCESS, GET_ONE_CUSTOMER_ADREESS_ERROR
} from "../actions/types";

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case ADD_CUSTOMER_ADREESS_REQUEST:
            return {
                loading: true,
            };
        case ADD_CUSTOMER_ADREESS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_CUSTOMER_ADREESS_ERROR:
            return {
                ...state,
                loading: false,
            };
        case GET_ONE_CUSTOMER_ADREESS_REQUEST:
            return {
                loading: true,
            };
        case GET_ONE_CUSTOMER_ADREESS_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_ONE_CUSTOMER_ADREESS_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
